import React from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/pay/bg.png'; // 배경 이미지 경로

const PayE = () => {
  const navigate = useNavigate();

  const handleGuideClick = () => {
    // 서비스 페이지의 이용가이드 탭으로 이동하면서 8번째 가이드를 자동으로 펼치도록 설정
    navigate('/service?tab=3&guide=8');
  };

  return (
    <section
      className="relative flex flex-col my-20 items-center justify-center text-center h-[500px] bg-cover bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="text-white px-4 max-w-[800px] mx-auto">
        <h2 className="text-xl md:text-4xl font-bold leading-relaxed md:leading-[60px]">
          학습권 등록 안내!!
          <br />
          학습권 등록은 관리자모드에서만 가능합니다.
          <br />
          기존에 회원가입하신 분은
          <br />
          관리자모드 로그인후 등록해주시기 바랍니다.
        </h2>
      </div>
      <div className="flex mt-6 space-x-4">
        <a 
          href="https://admin.dogopang.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-[#DFA532] text-white px-8 py-3 rounded-md hover:bg-[#f3cf68]"
        >
          학습권 등록
        </a>
        <button 
          onClick={handleGuideClick}
          className="bg-white text-black px-8 py-3 rounded-md hover:bg-gray-100 cursor-pointer"
        >
          이용가이드
        </button>
      </div>
    </section>
  );
};

export default PayE;